module.exports = __webpack_public_path__ + "static/img/C.0f82427.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/C.png
// module id = jQwo
// module chunks = 0